import { render, staticRenderFns } from "./SpecialOffers.vue?vue&type=template&id=2a995ab2&"
import script from "./SpecialOffers.vue?vue&type=script&lang=js&"
export * from "./SpecialOffers.vue?vue&type=script&lang=js&"
import style0 from "./SpecialOffers.vue?vue&type=style&index=0&id=2a995ab2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardsCourseCard: require('/opt/build/repo/components/Cards/CourseCard.vue').default,CartPrice: require('/opt/build/repo/components/Cart/Price.vue').default,CardsMoreInfoModal: require('/opt/build/repo/components/Cards/MoreInfoModal.vue').default})
